module.exports = __webpack_public_path__ + "img/newCompany.4ca9913b.svg";